import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { registerShipDispatch, addOrderDispatch, showcustomerDispatch } from '../../../reducers/HomeReducer';
import { selectCust } from '../../../reducers/UiReducer';
// import { addOrderDispatch } from '../reducers/HomeReducer';
// import { toggleModal } from '../reducers/UiReducer';
// import BasicModal from '../components/resuableComponents/BasicModal';

const ShippingForm = ({ filterData }) => {
	const { cart, modal, selCust } = useSelector((state) => state.ui);
	const { loginInfo, loading, markup, customerDetail, customer } = useSelector(
		(state) => state.home
	);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [pass, setPass] = useState('');
	function generatePassword(length = 12) {
		const chars =
			'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_-+=<>?';
		let password = '';
		for (let i = 0; i < length; i++) {
			password += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		setPass(password);
		return password;
	}
	useEffect(() => {
		generatePassword();
		dispatch(showcustomerDispatch(loginInfo?.token));
	}, []);

	const formik = useFormik({
		initialValues: {
			firstname: selCust ? selCust?.firstname : '',
			lastname: selCust ? selCust?.lastname : '',
			email: selCust ? selCust?.email : '',
			contact: selCust ? selCust?.contact : '',
			gstInNumber: selCust ? selCust?.gstInNumber : '',
			panNumber: selCust ? selCust?.panNumber : '',
			city: selCust ? selCust?.city : '',
			firmName: selCust ? selCust?.firmName : '',
			state: selCust ? selCust?.state : '',
			address: selCust ? selCust?.address : '',
			pincode: selCust ? selCust?.pincode : '',
			payment_option: '',
			payment_screenshot: null,
		},
		validationSchema: Yup.object({
			firstname: Yup.string().required('First name is required'),
			lastname: Yup.string().required('Last name is required'),
			gstInNumber: Yup.string().required('GST In Number is required'),
			panNumber: Yup.string().required('Pan Number is required'),
			contact: Yup.string()
				.matches(/^\d{10}$/, 'Contact must be a 10-digit number')
				.required('Contact is required'),
			email: Yup.string()
				.email('Invalid email address')
				.required('Email is required'),
			firmName: Yup.string().required('Firm Name is required'),
			city: Yup.string().required('City is required'),
			state: Yup.string().required('State is required'),
			pincode: Yup.string()
				.matches(/^\d{6}$/, 'Pincode must be a 6-digit number')
				.required('Pincode is required'),
			address: Yup.string().required('Address is required'),
			payment_option: Yup.string().required('Select a payment option'),
		}),
		onSubmit: (values) => {
			console.log('Form Submitted:', values);
			let registerForm = {
				firstname: values?.firstname,
				lastname: values?.lastname,
				email: values?.email,
				password: pass,
				confirm_password: pass,
				contact: values.contact,
				gstInNumber: values.gstInNumber,
				panNumber: values.panNumber,
				city: values.city,
				firmName: values.firmName,
				state: values.state,
				address: values.address,
				pincode: values.pincode,
			};
			if (selCust) {
				const formData = new FormData();
				formData.append('orderId', 'QWERT');
				formData.append('desc', 'Order Product');
				formData.append('bookingStatus', 'pending');
				formData.append('paymentStatus', 'pending');
				formData.append('userEmail', values.email);
				formData.append('userPhone', values?.contact);
				formData.append('first_name', values?.firstname);
				formData.append('last_name', values?.lastname);
				formData.append('address', values?.address);
				formData.append('city', values?.city);
				formData.append('state', values?.state);
				formData.append('pin', values?.pincode);
				formData.append(
					'baseFare',
					parseFloat(
						Number(
							filterData.reduce((accumulator, currentValue) => {
								return (
									accumulator +
									parseFloat(
										Number(
											Math.round(
												Number(
													Math.round(
														Number(
															Number(currentValue.set_quantity) *
																Number(currentValue.qnty)
														) * Number(currentValue.price_per)
													)
												)
											)
										)
									)
								);
							}, 0)
						)
					)
				);
				formData.append('gst', markup?.result[0]?.gst);
				formData.append('markup', 0.0);
				formData.append('pimage', values?.payment_screenshot);
				formData.append(
					'totalFare',
					parseFloat(
						Number(
							filterData.reduce((accumulator, currentValue) => {
								return (
									accumulator +
									parseFloat(
										Number(
											Math.round(
												Number(
													Math.round(
														Number(
															Number(currentValue.set_quantity) *
																Number(currentValue.qnty)
														) * Number(currentValue.price_per)
													)
												)
											)
										)
									)
								);
							}, 0)
						) +
							Number(
								filterData.reduce((accumulator, currentValue) => {
									return (
										accumulator +
										parseFloat(
											Number(
												Math.round(
													Number(
														Math.round(
															Number(
																Number(
																	Math.round(
																		Number(
																			Math.round(
																				Number(
																					Number(currentValue.set_quantity) *
																						Number(currentValue.qnty)
																				) * Number(currentValue.price_per)
																			)
																		)
																	)
																)
															) * Number(parseInt(markup?.result[0]?.gst))
														)
													) / 100
												)
											)
										)
									);
								}, 0)
							)
					)
				);
				formData.append('cust_id', selCust?.id);
				formData.append('deliveryDate', '2024-12-12');
				formData.append('cart', JSON.stringify(filterData));
				formData.append('tran_type', 'online');
				formData.append('status', '1');
				dispatch(
					addOrderDispatch(
						formData,
						filterData,
						navigate,
						Swal,
						selCust?.id,
						loginInfo?.token
					)
				);
			} else {
				dispatch(
					registerShipDispatch(
						registerForm,
						navigate,
						Swal,
						values,
						filterData,
						markup,
						loginInfo?.token
					)
				);
			}
		},
		enableReinitialize: true, // Allow reinitialization
	});

	return (
		<div className='shipping-form'>
			{/* <div className='mb-25'>
				<h4>Shipping Details</h4>
			</div> */}
			<form onSubmit={formik.handleSubmit} enableReinitialize={true}>
				{/* Dropdown Field */}
				<div className='form-group'>
					<select
						name='userType'
						onChange={(e) => {
							// Get the selected value
							const selectedValue = e.target.value;

							// Find the selected object from the customer.result array
							const selectedCustomer = customer.result.find(
								(i) => i.id === parseInt(selectedValue)
							);

							// Log the selected object to the console
							console.log('Selected Customer:', selectedCustomer);
							dispatch(selectCust(selectedCustomer));
						}}
						className={`form-control ${
							formik.touched.userType && formik.errors.userType
								? 'is-invalid'
								: ''
						}`}>
						<option value=''>Select Customer</option>
						{customer?.result?.map((i) => {
							return (
								<option value={i.id}>{`${i.firstname} ${i.lastname}`}</option>
							);
						})}
					</select>
					{formik.touched.userType && formik.errors.userType && (
						<div className='invalid-feedback'>{formik.errors.userType}</div>
					)}
				</div>
				{[
					{ name: 'firstname', placeholder: 'First name *' },
					{ name: 'lastname', placeholder: 'Last name *' },
					{ name: 'address', placeholder: 'Address *' },
					{ name: 'email', placeholder: 'Email *', type: 'email' },
					{ name: 'gstInNumber', placeholder: 'Gst Number *', type: 'text' },
					{ name: 'panNumber', placeholder: 'Pan Number *', type: 'text' },
					{ name: 'firmName', placeholder: 'Firm Name *', type: 'text' },
					{ name: 'contact', placeholder: 'Contact *', type: 'text' },
					{ name: 'city', placeholder: 'City / Town *' },
					{ name: 'state', placeholder: 'State / County *' },
					{ name: 'pincode', placeholder: 'Postcode / ZIP *' },
				].map(({ name, placeholder, type = 'text' }) => (
					<div className='form-group' key={name}>
						<input
							type={type}
							name={name}
							value={formik.values[name]}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={placeholder}
							className={`form-control ${
								formik.touched[name] && formik.errors[name] ? 'is-invalid' : ''
							}`}
						/>
						{formik.touched[name] && formik.errors[name] && (
							<div className='invalid-feedback'>{formik.errors[name]}</div>
						)}
					</div>
				))}

				{/* Payment Options */}
				<div className='payment_option'>
					{[
						{ value: 'checkPayment', label: 'Pay Through QR or Bank Details' },
					].map(({ value, label }) => {
						return (
							<div className='custome-radio' key={value}>
								<input
									className='form-check-input'
									type='radio'
									name='payment_option'
									value={value}
									// Disable the wallet radio if wallet balance is less than cart amount
									checked={formik.values.payment_option === value}
									// onChange={formik.handleChange}
									onChange={(event) => {
										// Call Formik's handleChange
										formik.handleChange(event);

										// Check if the selected value is 'wallet' and log to console
										if (event.target.value === 'checkPayment') {
											// dispatch(toggleModal(true));
										}
									}}
									style={{
										appearance: 'none', // Remove default styling
										width: '20px',
										height: '20px',
										borderRadius: '50%',
										border: '2px solid #007bff',
										backgroundColor:
											formik.values.payment_option === value
												? '#007bff'
												: 'transparent',
										display: 'inline-block',
										cursor: 'pointer',
										position: 'relative',
										marginRight: '10px',
									}}
									id={`payment_option_${value}`} // Ensure each radio button has a unique ID
								/>
								<label
									onClick={() => {
										if (value === 'checkPayment') {
											// dispatch(toggleModal(true));
										}
									}}
									className='form-check-label'
									htmlFor={`payment_option_${value}`}>
									{label}
								</label>
							</div>
						);
					})}

					{/* File Upload for Check Payment */}
					{formik.values.payment_option === 'checkPayment' && (
						<div className='form-group' style={{ marginTop: 10 }}>
							<label htmlFor='payment_screenshot'>
								Upload Payment Screenshot
							</label>
							<input
								type='file'
								id='payment_screenshot'
								name='payment_screenshot'
								accept='image/*'
								onChange={(event) => {
									// Store the file in Formik state
									formik.setFieldValue(
										'payment_screenshot',
										event.currentTarget.files[0]
									);
								}}
								className='form-control'
							/>
							{/* Show error if no file is uploaded and checkPayment is selected */}
							{formik.values.payment_option === 'checkPayment' &&
								!formik.values.payment_screenshot && (
									<div
										className='error-message'
										style={{ color: 'red', fontSize: '14px' }}>
										Please upload the payment screenshot.
									</div>
								)}
						</div>
					)}

					{/* Example of form submission or button to proceed */}
					<button
						style={{ marginTop: 10 }}
						type='submit'
						className='btn btn-primary'
						disabled={
							formik.values.payment_option === 'checkPayment' &&
							!formik.values.payment_screenshot
						}>
						Proceed with Payment ₹{' '}
						{Number(
							cart?.reduce((accumulator, currentValue) => {
								return (
									accumulator +
									parseFloat(
										Number(
											Math.round(
												Number(
													Math.round(
														Number(
															Number(currentValue.set_quantity) *
																Number(currentValue.qnty)
														) * Number(currentValue.price_per)
													)
												)
											)
										)
									)
								);
							}, 0)
						) +
							Number(
								cart?.reduce((accumulator, currentValue) => {
									return (
										accumulator +
										parseFloat(
											Number(
												Math.round(
													Number(
														Math.round(
															Number(
																Number(
																	Math.round(
																		Number(
																			Math.round(
																				Number(
																					Number(currentValue.set_quantity) *
																						Number(currentValue.qnty)
																				) * Number(currentValue.price_per)
																			)
																		)
																	)
																)
															) * Number(parseInt(markup?.result[0]?.gst))
														)
													) / 100
												)
											)
										)
									);
								}, 0)
							)}
					</button>
				</div>
			</form>
			{/* <BasicModal /> */}
		</div>
	);
};

export default ShippingForm;
